//import { List, message, Spin, Tree } from 'antd';
import { message, Tree } from 'antd';
import { DataNode } from 'antd/lib/tree';
import React from 'react';
//import InfiniteScroll from 'react-infinite-scroller';
import { graphicApi } from '../../../api';
import { Tuple } from '../../../model/CommonModel';

// Internal state for the component
interface State {
	data: Tuple[];
	loading: boolean;
	hasMore: boolean;
	pageNumber: number;
	treeData: DataNode[];
}

// Normal properties for the component
interface OwnProps {}

// combine them together
type Props = OwnProps;

class MapItemList extends React.Component<Props, State> {
	pageSize: number = 10;

	constructor(prop) {
		super(prop);
		this.state = {
			data: [],
			loading: false,
			hasMore: true,
			pageNumber: 0,
			treeData: [],
		};
	}

	componentDidMount() {
		this.fetchData(res => {
			this.setState({
				treeData: [
					{
						key: '0-0',
						title: 'Drawings',
						children: res.map((x, index) => ({
							key: `0-0-${index}`,
							title: x.Item1,
							isLeaf: true,
						})),
					},
				],
				loading: false,
				data: res,
			});
		});
	}

	componentDidCatch(error, errorInfo) {
		console.log(error, errorInfo);
	}

	// handleInfiniteOnLoad = () => {
	// 	let { data } = this.state;
	// 	this.setState({
	// 		loading: true,
	// 	});

	// 	this.fetchData(res => {
	// 		data = data.concat(res);
	// 		this.setState({
	// 			treeData: [
	// 				{
	// 					key: '0-0',
	// 					title: 'Drawings',
	// 					children: data.map((x, index) => ({
	// 						key: `0-0-${index}`,
	// 						title: x.Item1,
	// 						isLeaf: true,
	// 					})),
	// 				},
	// 			],
	// 			loading: false,
	// 		});
	// 	});
	// };

	private fetchData = callback => {
		let { pageNumber, hasMore } = this.state;

		graphicApi
			.retrieveMaps(pageNumber, this.pageSize)
			.then(data => {
				pageNumber++;
				if (data.length < this.pageSize) {
					message.warning(_('NoMoreDataAvailable'));
					hasMore = false;
				}

				this.setState({
					pageNumber: pageNumber,
					hasMore: hasMore,
				});

				callback(data);
			})
			.catch(e => console.log(e));
	};

	render() {
		// return (
		// 	<InfiniteScroll
		// 		initialLoad={false}
		// 		pageStart={0}
		// 		loadMore={this.handleInfiniteOnLoad}
		// 		hasMore={!this.state.loading && this.state.hasMore}
		// 		useWindow={false}>
		// 		<List
		// 			dataSource={this.state.data}
		// 			renderItem={item => (
		// 				<List.Item key={item.Item2}>
		// 					<List.Item.Meta
		// 						title={
		// 							<a href='#' onClick={() => openMap(item.Item2)}>
		// 								{item.Item1}
		// 							</a>
		// 						}
		// 					/>
		// 				</List.Item>
		// 			)}>
		// 			{this.state.loading && this.state.hasMore && (
		// 				<div>
		// 					<Spin />
		// 				</div>
		// 			)}
		// 		</List>
		// 	</InfiniteScroll>
		// );

		const { DirectoryTree } = Tree;
		return (
			<DirectoryTree
				treeData={this.state.treeData}
				expandedKeys={['0-0']}
				onSelect={(selectedKeys, { node }) => {
					if (node.key.toString().length > 3) {
						const findNode = this.state.data.find(x => x.Item1 === node.title);
						openMap(findNode.Item2);
					}
				}}
			/>
		);
	}
}

export { MapItemList };
